export default {
    tms: {

    },
    generic: {
        Home:"主頁",
        ReporMaster: "Report Master",
        GenericName: "Generic Name",
        ModuleCode: "模塊編碼",
        Description: "描述",
        FunctionCode: "功能編碼",
        PageTitleCode: "頁標題編號",
        IsPaging: "是否分頁",
        IgnoreCount: "上/下頁",
        Creator: "創建人",
        CreateDate: "創建日期",
        Modifier: "修改人",
        ModifyDate: "修改日期",
        GMCUID: "GMC UID",
        SCHEMAUID: "SCHEMA UID",
        UIAction: "UI Action",
        Validation: "驗證",
        Editable: "編輯",
        EditCondition:"編輯條件",
        Searchable: "查詢",
        DefaultValue: "默認值",
        Madatory: "必填",
        Displayable: "顯示",
        Sequence: "序列",
        Condition: "條件",
        Mandatory: "必填",
        AndOr: "並且/或者",
        GCDUID: "GCD UID",
        ParentGCDUID: "父 GCD UID",
        IfOrNotMove:"是否需要移庫操作?",
        TableName: "表名",
        EnglishName: "英文名稱",
        CnName: "中文名稱",
        TraditionalCNName: "繁體中文名稱",
        KorName: "韓語名稱",
        thName: "泰语名稱",
        jpName: "日语名稱",
        Header: "主信息",
        TableAlias: "表別名",
        FieldName: "字段名",
        FieldType: "字段類型",
        FieldLength: "字段長度",
        FieldLengthDecimal: "字段長度小數位",
        ForeignTable: "Foreign 表",
        ForeignFIELD: "Foreign 字段",
        LanguageCode: "語言編碼",
        Module: "模塊",
        SubPage: "子頁面",
        SubModule: "子模塊",
        Function: "功能",
        PageTitle: "頁主題",
        Decimal: "小數位",
        Edit: "編輯",
        Add: "添加",
        More: "更多",
        AreyoudeleTask: "確定要刪除所選記錄嗎",
        Yes: "是",
        No: "否",
        Delete: "刪除",
        Zip: "壓縮Zip",
        Up: "上",
        Down: "下",
        Store: "存儲",
        ButtonGroupName: "按鈕分組名",
        Apply: "應用",
        Configuration: "配置",
        Name: "名",
        RenderType: "渲染類型",
        Type: "類型",
        Code: "編碼",
        ViewType: "視圖類型",
        PatternType: "模式類型",
        ExtenalAPI: "外部 API",
        MapToModule: "模塊映射",
        FieldMap: "字段映射",
        BehaviorPattern: "行為模式",
        Parameters: "參數",
        CustPage: "CustPage",
        Action: "行為",
        Width: "寬",
        ConsParameter: "Cons. 參數",
        Constrainttable: "約束表",
        Seq: "序列",
        ValidationSQL: "校驗SQL",
        operate: "操作",
        Group: "分組",
        FKTable: "外鍵表",
        FKFieldName: "外鍵名",
        SQLParameters: "SQL 參數",
        defaultValue: "默認值",
        DisplayColumns: "顯示列",
        SortSeq: "排序序列",
        OrderBy: "以..排序",
        Refresh: "刷新",
        PagePropertyGroupName: "頁面屬性組名",
        Disaplyable: "顯示",
        Like: "模糊",
        IsShowTitle: "是否標題",
        ShowTitleSeq: "顯示標題序列",
        OptionType: "選擇類型",
        ExtentionValue: "延伸值",
        GenIdtype: "Gen Id type",
        Hyperlink: "超連結",
        Isitunique: "是否唯一",
        Statistics: "統計",
        DataFormat: "數據格式",
        FieldPattern: "字段樣式",
        GenericParameters: "配置參數",
        DefaultSelected: "默認選擇",
        IsReserveAdmin: "是否儲備管理",
        TitleInfo: "標題信息",
        UniqueParameter: "唯一參數",
        Depend: "依賴",
        IsDefType: "IsDefType",
        ConfigurationMethod: "配置的計算方法",
        CalcParameters: "計算參數",
        CalcType: "計算類型",
        SurfixParameter: "後綴參數",
        ComputationalEvent: "計算事件",
        TriggerFields: "觸發字段",
        IsTrigger: "是否觸發器",
        Publish: "發布",
        AdvanceSearch: "高級查詢",
        SearchTemplate: "過濾模板",
        IsDefault: "是否默認",
        Loadable: "可加載",
        IsExtra: "是否額外",
        ExtraParameters: "額外參數",
        TemplateName: "模板名稱",
        CreateTime: "創建時間",
        Copy: "復製",
        CreateGenericData: "新建基礎數據",
        AppendGenericData: "附加基礎數據",
        DeleteGenericData: "刪除基礎數據",
        PleasemoduleonlyGeneric: "請確保一個模塊只有一個基礎數據啟動",
        DBSchema: "DB Schema",
        PageProperty: "頁面屬性",
        SQL: "SQL",
        ConfigSQL: "配置 SQL",
        Behavior: "行為",
        ForOption: "可選",
        StartupModule: "啟動模塊",
        UseViewSQL: "使用視圖SQL",
        ReportView: "報表視圖",
        TableViewName: "表/視圖 名",
        FiledName: "字段名",
        Basic: "基礎",
        AliasName: "別名",
        SubModuleCode: "子模塊編碼",
        SubModuleName: "子模塊名称",
        FunctionName: "功能名",
        FunctionLevel: "功能級別",
        ParentFunctionCode: "父功能編碼",
        FunctionSeq: "功能序列號",
        FunctionURL: "功能 URL",
        LangCode: "語言",
        Menu: "菜單",
        GenericMenu: "Generic 菜单",
        RelationTable: "關聯表",
        UserMenu: "用戶菜單",
        FunctionAPI: "功能 API",
        Status: "狀態",
        NotInactive: "不允許發布已經發布或者不啟用的配置",
        Mapto: "映射給",
        Project: "項目",
        Usage: "作用",
        Source: "來源",
        TargetTo: "目標紙箱",
        ExcelType: "Excel 類型",
        OnlyAllowLetter: "只允許輸入字母",
        Export: "導出",
        SourceMap: "源程序映射",
        MapToView: "映射到視圖",
        TargetMap: "目標印射",
        Excel: "Excel",
        SelectedMatched: "所選列需要匹配.",
        DataDuplication: "數據重復",
        UnUploadFile: "請上傳文件！",
        isShowCopy:"複制",
        copySuccess:"複制成功",
        totalOf:"共 ",
        Records:"記錄",
    },
    userlang: {
        Address1: "地址1",
        Address2: "地址2",
        Address3: "地址3",
        Address4: "地址4",
        Postal: "郵編",
        Street: "街道",
        District: "區",
        Latitude: "維度",
        Longitude: "經度",
        Country: "國家",
        Enable: "可用",
        Disable: "不可用",
        Empower: "授權",
        Edit: "編輯",
        EditUser: "編輯用戶",
        UserAccount: "用戶賬號",
        LoginAccount: "用戶賬號",
        DispName:"用戶名稱",
        Email: "郵箱",
        EmailInfoFrom: "輸入的郵箱不合法!",
        FirstName: "名",
        MiddleName: "中間名",
        LastName: "姓",
        DisplayName: "顯示名",
        Title: "標題",
        Gender: "性別",
        Male: "男",
        Female: "女",
        Company: "公司",
        Department: "部門",
        Position: "職位",
        Telephone: "電話",
        City: "城市",
        SelectCity: "請選擇城市",
        TimeZone: "時區",
        Language: "語言",
        english:"英語",
        englishName:"英語名字",
        sumplifiedName:"簡體中文名字",
        traditionalName:"繁體中文名字",
        koreanName:"韓語名字",
        japaneseName:"日語名字",
        thaiName:"泰語名字",
        Jtlang: "簡體中文",
        ftlang: "繁體中文",
        korlang: "한국어",
        thlang: "ภาษาไทย",
        jplang: "日本語",
        Orgnization: "組織",
        Project: "項目",
        Delete: "刪除",
        NorecordFound: "未找到記錄",
        Organization: "組織",
        Warehouse: "倉庫",
        Address: "地址",
        Save: "保存",
        AccessRights: "訪問權限",
        Pleaseselect: "請選擇",
        Role: "角色",
        PleaseOneleast: "請最少選擇一條記錄.",
        SaveSuccessfully: "保存成功",
        AddProject: "添加項目",
        AddWarehouse: "添加倉庫",
        defaultOrg:"默认组织",
        defaultProj:"默认项目",
        domain:"域",
        useredQr:"用戶QR"
    },
    convertCountResult: {
        title: "轉換盤點結果",
        filenameStartFrom: "檔名起始字元",
        importSuccess: "匯入成功",
        pleaseUpload: "請上傳檔案",
        noFileToDownload: "暫無可下載的檔案",
        invalidFilename: "檔名起始字元必須為 2、S 或 Q",
        invalidFileType: "僅支援上傳 .xlsx 格式的檔案"
    },
    publicLang: {
        DeleteSuccess: "刪除成功",
        HelpMessage: "幫助",
        PreviousPage: "上一頁",
        NextPage: "下一頁",
        Page: "頁",
        CourierNumberIsNotNull: "快遞單號不能為空",
		CourierNumber:"快遞單號",
        InputRequiredValue: "請先填寫必填項!",
        containerIdNotExists: "箱號不存在或已經收貨",
        CartonIdNumNotExists: "箱號不存在或已經收貨",
        PleaseOneLeast: "請最少選擇一條記錄.",
        AreUpadte: "是否更新所選記錄?",
        NotAllowtodeleteCancel: "不允許刪除/取消",
        Notprintfirst: "不允許打印, 請先做分配.",
        Notprintpackfirst: "不允許打印, 請先掃描裝箱.",
        ProjectandWarehouse: "項目 和 倉庫",
        AlertMessage: "彈出信息",
        NewTemplateName: "新模板名稱",
        ProjectTemplate: "項目模板",
        StyleSetting: "樣式設置",
        NavigationMode: "導航模式",
        LeftLayout: "左側菜單布局",
        TopLayout: "頂部菜單布局",
        Arecancel: "請確認是否刪除?",
        Areconfirm: "請確認是否提交?",
        Yes: "是",
        No: "否",
        SKUSearch: "商品查詢",
        StatusNotNew:"訂單狀態不能是新建狀態",
        PubOk: "OK",
        theIstAdministrator: "當前用戶還沒有分配權限,請聯系管理員.",
        PleaseSltAtleast: "請最少選擇一條記錄.",
        ColumnSearchRequired: "請先設定查詢條件後再載入資料.",
        PleaseCheckDisplayableFirst: "請先檢查可顯示內容！",
        pleaseOneOnly: "請只選擇一條記錄.",
        SelectRestrict: "選擇數據的數目不允許超100行",
        PleaseFirst: "請選擇一條記錄.",
        DraglistSort: "拖動列表以進行排序",
        CreatTime: "創建時間",
        Clear: "清除",
        Save: "保存",
        UpdateSuccess: "更新成功",
        Project: "項目",
        PleaseSelect: "請選擇",
        Required: "必須的",
        ThenotEmail: "輸入的郵箱不合法",
        PleaseEnter: "請輸入",
        PleaseMobileNumberCorrectly: "請輸入正確的電話號碼",
        RequireNumerFormat: "請輸入數字格式",
        SystemAdministrator: "系統配置錯誤，請聯系管理員.",
        Download: "下載",
        Preview: "預覽",
        Wrongconfiguration: "配置錯誤",
        NotAllowToOverReceive: "不允許超收",
        Search: "查詢",
        Close: "關閉",
        sendEdi: "發送Edi",
        rePrint: "預打印",
        Cancel: "取消",
        Confirm: "確認",
        CheckComplete: "復核完成",
        CancelCheckComplete: "取消復核完成",
        Template: "模板",
        Loading: "裝車",
        notExistScanInList: "{0} 不存在入庫掃描列表中",
        prompt: "提示", // 提示
        closePrompt:"是否確認關閉訂單？",
        cancelPrompt: "是否確認取消訂單? 該操作不可逆轉。",
        IncorrectConfiguration: "配置錯誤",
        NoreportFound: "沒有找到報表",
        PleaseinputEmail: "請輸入郵箱!",
        Upload: "上傳",
        UploadPhoto: "上傳圖片",
        UploadSuccess: "上傳成功!",
        DownloadCenter: "下載中心",
        FileName: "文件名",
        Action: "功能",
        overScanMsg:"{0} 不允許超收",
        overRemoveMsg:"{0} 不允許過量刪除",
        locationIsNull:"库位不允许为空",
        ConfirmShipment: "確定發運?",
        LastSKUCheckCompletePrompt:"訂單裝箱完成，請復核.",
        statusError:"{0}  狀態錯誤",
        waveIdIsNotEmpty:"{0} 訂單已經存在波次號",
        UploadFileOverSize: "上傳的文件超過了大小限制，請檢查.",
        UploadFailed: "上傳失敗",
        DownloadFailed: "下載失敗",
        cardNeedReplace:"需更換卡片",
        NoPickedStockInContainer:"這個集裝箱沒有揀貨!",
        needToHangGooseDownGoldMedal:"需掛鵝絨金牌",
        requestApproval:"申請審批",
        cancelRequest:"取消申請",
        MustBeGreaterThanZero: "{0} 必須大於0"
    },
    roleGe: {
        RoleLevel: "角色級別",
        ModuleName: "模塊名",
        SubModuleName: "子模塊名",
        Add: "添加",
        Delete: "刪除",
        Edit: "編輯",
        EditRole: "編輯角色",
        CreateRole: "新建角色",
        RoleName: "角色名",
        RoleType: "角色類型",
        PleaseSelect: "請選擇",
        Description: "描述",
        Save: "保存",
        pleaseOneOnly: "請選擇一條記錄",
        SaveuSccessfully: "保存成功",
        RuleType: "規則類型",
        RuleName: "規則名",
        Organization: "組織",
        Project: "項目",
        Search: "查詢",
        Creator: "創建人",
        CreateTime: "創建時間",
        Modifier: "修改人",
        ModifiyTime: "修改時間",
        Next: "下一個",
        SortSubmit: "順序提交",
        Inventory: "庫存",
        TableName: "表名",
        FieldName: "字段名",
        InventoryFieldName: "庫存字段名",
        FieldType: "字段類型",
        Condition: "條件",
        CustomizeValue: "自定義值",
        OrderBy: "以..排序",
        Operation: "操作",
        SO: "訂單",
        Rule: "規則",
        Grouping: "分組",
        GroupingAndOrderBy: "分組和排序",
        ReportSetting: "報表設置",
        Import: "導入",
        Lookup: "查找",
        ReportName: "報表名",
        ConfigEnableUser: "配置可用用戶"
    },
    menu: {
        NotificationList: "通知列表",
        Read: "已讀",
        Unread: "未讀",
        ViewMore: "查看更多",
        YouhaveViewedNotifications: "您已經查看了所有通知列表.",
        Receiver: "接收者",
        ReadTime: "可讀時間",
        Status: "狀態",
        Subject: "主題",
        RefType: "參考編號類型",
        RefNum: "參考編號",
        StartTime: "開始時間",
        CompleteTime: "完成時間",
        FirstName: "名",
        LastName: "姓",
        DisplayName: "顯示名",
        MiddleName: "中間名",
        Email: "郵箱",
        Title: "標題",
        Gender: "性別",
        Male: "男",
        Female: "女",
        Department: "部門",
        Position: "職位",
        Telephone: "電話",
        City: "城市",
        TimeZone: "時區",
        DefaultLanguage: "默認語言",
        PerformanceFeedback: "績效反饋",
        SimulateUser: "模擬用戶",
        ReleaseUser: "發布用戶",
        PrintNode: "打印節點",
        Logout: "退出",
        NoRecordfound:"未找到記錄"
    },
    easyCron: {
        Specify: "說明",
        NoSet: "No Set",
        OnlyDaysWeeksSet: "只能設置其中的一天和一個星期",
        Perday: "每天",
        Between: "兩者之間",
        Day: "天",
        to: "到",
        PreHour: "每小時",
        Hour: "小時",
        From: "從",
        PerMinute: "每分鐘",
        Minute: "分鐘",
        PerYear: "每年",
        Year: "年",
        Start: "開始",
        Expire: "過期",
        dayWeekNoset: "請定義天或星期",
    },
    pubGicSet: {
        EachGroupRow: "每單行數",
        SplitRec: "拆分收貨單",
        SelectSKU: "選擇SKU",
        SelectOneSKU:"請選擇一個SKU",
        QuantityTypeError: "掃描數量類型錯誤",
        soQty: "訂單數量",
        OrderType: "訂單類型",
        SelectFieldName: "選擇字段名",
        SkuDesc: "商品描述",
        WarehouseCode: "倉庫編號",
        NoRecordfound: "沒有找到記錄!",
        DragTheListTosort: "拖動列表以進行排序",
        AdvanceSearch: "高級查詢",
        AdvanceSort: "高級排序",
        FreezeCol: "凍結 Col",
        Clear: "清除",
        Sort: "排序",
        Search: "查詢",
        FieldName: "字段名",
        OrderBy: "以..排序",
        Name: "名稱",
        PleaseName: "請輸入名稱",
        SearchTemplate: "過濾模板",
        AdvanceSearcheTemplate: "高級查詢模板",
        AreyoudeleTask: "確定要刪除所選記錄嗎?",
        UserResetChanges: "以下操作將會把這用戶已修改的權限清除, 請確認是否繼續執行?",
        ResetPasswordsConfirm: "密碼將被重置為 NULL，請確認是否繼續？",
        ResetPasswordsButton: "重置密碼",
        InvalidSKU: "SKU {0} 無效.",
        NotEnoughQtyPack: "{0} 不允許過量裝箱",
        NotEnoughQtyCancelPack: "{0} 不允許過量取消裝箱",
        CartonClose:"{0} 已關箱.",
        UnpackedErrorWithEmptyCarton: "{0} 空箱不能再取消了.",
        NotAllowOverPack: "{0} 不允許超量打包.",
        ScanPackDecodeError:"掃描條碼格式錯誤.",
        NotEnoughSkuRemoved: "箱子沒有足夠{0}的數量",
        unscanpackDataNotCancel: "未掃描打包的數據無法取消",
        cartonQtyTooLarge: "箱子數量過大",
        Yes: "是",
        No: "否",
        delete: "刪除",
        PleaseTamplateNameFirst: "請先選擇模板名稱",
        SaveSuccess: "保存成功",
        Mandatory: "必填",
        Pleaseselect: "請選擇",
        SelectPicture: " 請選擇一張圖片",
        Split: "分割",
        FromValue: "From Value",
        ToValue: "To Value",
        NotAllowToSplit: "不允許分單",
        PleaseSelectFieldName: "請選擇字段名稱",
        FieldAddedRepeatedly: "字段名不能重復添加",
        ToLocationRequired: "目標庫位必填",
        QtyRequired: "數量必填",
        qtyTolocatioRequired: "目標庫位數量必填",
        PleaseCheckTheData: "請檢查數據",
        ToValueCannotBeEmpty:"To value 不能為空",
        RecQty: "收貨數量",
        Location: "庫位",
        ToLocation: "目標庫位",
        LocationISrequired: "庫位必填",
        NewContainer: "新貨櫃",
        LoadedCartonQty: "已裝車箱子數量",
        ContainerNo: "装车號",
        SSCC: "箱號/速递號碼",
        trackingNo: "速递號碼",
        SSCC1: "箱號",
        AmrContainerNo:"AMR 周轉箱號",
        iWmsContainerNo:"iWMS 周轉箱號",
        HiddenTable: "隱藏表單",
        logisticsid: "速递號碼",
        RemoveCartonFromContainer: "從貨櫃中取出紙箱",
        RelID: "訂單號碼",
        PackID: "打包 ID",
        Carton: "箱號#",
        SKUQty: "商品數量",
        NewPallet: "新托盤",
        PalletNo: "托盤號",
        WeightPallet:"托盤重量",
        Length: "長",
        InputaNumber: "請輸入數字",
        Width: "寬",
        Height: "高",
        CBM: "體積",
        Weight: "重量",
        WeightUOM: "重量單位",
        LoadedPalletQty: "已裝車托盤數量",
        RemovePalletfromContainer: "請從貨櫃移除托盤",
        Remarks: "備註",
        Desc:"詳情",
        SKU: "商品",
        LogicalWH: "Logical WH",
        LotID: "批次 ID",
        AvailableQty: "可用數量",
        AdjustQty: "調整數量",
        ReasonCode: "調整原因",
        Action: "加或減",
        Adjust: "調整",
        NotEnoughInventoryToAdjust:"沒有足夠庫存調整",
        ActionCannotBeEmpty: "加或減 不允許為空",
        ToLocationCannotBeEmpty: "目標庫位不允許爲空",
        ToSkuCannotBeEmpty: "目標商品不允許為空",
        NotEnoughInventoryToMove : "沒有足夠庫存轉移",
        DataNotChange: "數據未發生改變，不需要保存",
        DataModifyNotSave: "修改後的數據未保存",
        BatchUpdateShipment: "批量更新發運",
        BathUpdate: "批量更新",
        BatchUpdate: "批量更新",
        ButtonConfig: "按鈕配置",
        ButtonConfigName: "按鈕配置名稱",
        BePrint: "BePrint",
        ActionValue: "Action Value",
        DeAllocation: "取消分配",
        BatchNo: "生產批號",
        Qty: "數量",
        originalLotId: "源批次 ID",
        soLineSeq: "訂單行序列",
        PickLineSeq: "揀貨行序列",
        ModifyTime: "修改時間",
        ShipOutDate: "出單日期",
        GenerateLocation: "庫位生成",
        RowName: "行名稱",
        ColumnInRow: "列的行",
        LevelInRow: "Level in Row",
        BinsinLocation: "Bins in Location",
        CartonToContainer: "箱子到貨櫃",
        CartonToPallet: "箱子到托盤",
        PalletToContainer: "托盤到貨櫃",
        Error: "錯誤",
        Lookup: "查找",
        PrePrintLPN: "Pre-Print LPN",
        NumberOfLPNLabelRequired: "LPN 標簽號必填",
        Print: "打印",
        ReprintLPN: "預打印 LPN",
        Lpn:"LPN",
        Reprint: "預打印",
        LastPrinted: "最後打印",
        MoveLogic: "移庫邏輯",
        Reason:"Reason",
        FromLocation: "原始庫位",
        MoveQty: "移庫數量",
        ColumnName: "字段名",
        printReportColumn: "打印報表字段名",
        ScanIn: "入庫掃描",
        RecID: "訂單號碼",
        CartonID:"纸箱 ID",
        TraceID:"跟蹤 ID",
        ContainerId:"周轉箱",
        CartonIdNum: "箱號",
        DeleteCartonID:"刪除箱號",
        CartonIdQty:"箱號数量",
        CartonIdNumRegExp:"箱號正則表達式錯誤",
        CartonIdNumFormatError:"錯誤箱號# {0} , 請重新掃瞄",
        ContainerIdIsEmpty:"周轉箱必填",
        EPC:"防偽碼",
        EPCIsEmpty:"防偽碼必填",
        EPCFormatError:"防僞碼異常，請重新識別.",
        EpcQtyMustBeOne:"防偽碼只能單件掃描",
        ConvertToReceive:"轉換為接收",
        CancelGR: "取消GR",
        NewGR: "新 GR",
        Descr: "描述",
        ASNQty: "預收貨數量",
        OutstandingQty: "未扫描数量",
        ContainerIdQty: "周转箱数量",
        ScanAction: "掃描事件",
        RemoveSku:"删除",
        addSku:"增加",
        StockStatus: "庫存狀態",
        LockScanQty: "鎖住掃描數量",
        LockContainer: "删除箱号",
        NoofSKU: "商品種類",
        NoofCartonID: "紙箱編號",
        UOM: "體積",
        ScanPack: "掃描裝箱",
        WaveID: "波次 ID",
        CancelPack: "取消裝箱",
        PrintPackingList: "打印揀貨單",
        PackingList: "打印裝箱單",
        AllocatedQty: "分配數量",
        PackedQty: "打包數量",
        PackedQty2: "打包數量",
        RemoveScanItem: "刪除掃描項目",
        IsCarton: "Is Carton",
        ScanInDirectly:"直接掃描",
        IsPrePack: "Is Pre-Pack",
        IsTraceId: "Is Trace Id",
        UnpackQty: "未打包數量",
        Detail: "明細",
        Percentage: "百分比",
        NoofCarton: "紙箱編號",
        Createdby: "創建人",
        CloseAndNew: "關閉 和 新建",
        New: "新建",
        Remove: "移除",
        Append: "追加",
        ImportScanningFile: "導入掃描檔案",
        ImportSacnningFileGroupName: "導入掃描檔案",
        PrintSSCC: "打印箱貼",
        PrintCarton: "打印箱貼",
        CartonNoSSCC: "Carton No./SSCC",
        ScannedQty: "掃描數量",
        CartonNo: "紙箱編號",
        CartonType: "箱子類型",
        DimUOM: "體積單位",
        GrossWeight: "毛重",
        NetWeight: "凈重",
        PleaseNewOneCartonFirst: "請先生成一個紙箱",
        Nosscc: "缺失SSCC, 請輸入掃瞄所需SSCC",
        CancelTransit: "取消發運",
        Transit: "發運",
        Step: "步驟",
        FromQty: "原始數量",
        ToQty: "目標數量",
        ToSku: "目標商品",
        FromSku: "原始商品",
        CourierEdi: "Courier EDI",
        IntersoftGenerateLabel: "Intersoft Generate Label",
        IntersoftCancelLabel: "Intersoft Cancel Label",
        IntersoftGenerateMainfest: "Intersoft Generate Mainfest",
        exportPackageData: "導出裝箱數據",
        orderCheckCompleteStartTime: "訂單複核開始時間",
        orderCheckCompleteEndTime: "訂單複核結束時間",
        whetherToPrintOnlyCompletedOrders: "是否只打印已複核訂單",
        addSoToWave:"訂單關聯波次",
        waveId:"波次ID",
        ref01:"參考編碼01",
        ref02:"參考編碼02",
        ref03:"參考編碼03",
        ref04:"參考編碼04",
        ref05:"參考編碼05",
        gift:"贈品",
        notGiftScanAntiCode:"非贈品，需掃描防偽碼.",
        searchCartonByWave:"波次查詢箱號",
        importSscc:"導入箱號",
        pleaseScanAntiCode:"請掃描防偽碼",
    },
    manual: {
        Manual: "手動",
        New: "新建",
        AddToPick: "添加到揀貨",
        Unpick: "取消揀貨",
        SO: "訂單編號",
        Sku: "商品",
        RecID: "訂單號碼",
        BatchNo: "批號",
        SODate: "訂單日期",
        AllQty: "分配數量/訂單數量y",
        AllocateLocation: "分配庫位",
        Status: "狀態",
        LotID: "批次 ID",
        RecDate: "收貨日期",
        RecQty: "收貨數量",
        AvailableQty: "可用數量",
        AllocateQty: "分配數量",
        ShippedQty: "發運數量",
        MANUFACTUREDate: "加工日期",
        EXPIRYDate: "有效期",
        SHELFDate: "上架日期",
        NewpickPleasego: "創建新的揀貨單並繼續"
    },
    login: {
        SignAccount: "用您現有的帳戶登錄",
        loginTitle1: "歡迎回來",
        loginTitle2: "請登錄您的帳戶",
        loginTitle3: "兩步驟驗證",
        loginTitle4: "這個額外步驟可證明當試登入賬戶的確實是你本人",
        loginTitle5:"透過以下電話號碼接收驗證碼：**** **",
        loginTitle6:"",
        loginTitle7:"需支付",
        loginTitle8:"一般簡訊費用",
        loginTitle9:"透過電郵接收驗證碼",
        loginTitle10:"驗證碼",
        loginTitle11:"請輸入驗證碼",
        loginTitle12:"是否信任此瀏覽器？",
        loginTitle13:"您仍然需要密碼才能登入網站，但下次登入時，不會再要求您輸入驗證碼。(未來",
        loginTitle27:"天)",
        loginTitle14:"透過Google或Microsoft Authenticator",
        loginTitle15:"等應用程式取得程式碼",
        loginTitle16:"設定",
        loginTitle17:"取消設定",
        loginTitle18:"安裝您選擇的TOTP",
        loginTitle19:"（基於時間的一次性密碼）驗證器",
        loginTitle20:"掃描二維碼",
        loginTitle21:"或",
        loginTitle22:"將'密鑰'輸入至您的",
        loginTitle23:"驗證器應用程式",
        loginTitle24:"完成設定",
        loginTitle25:"密鑰",
        loginTitle26:"密鑰錯誤",
        Verify: "驗證",
        PleaseUsername: "請輸入用戶名!",
        Username: "用戶名", // user name
        Password: "密碼",
        language: "語言",
        PleasePassword: "請輸入密碼!",
        ForgotPassword: "忘記密碼",
        KeepIn: "保持登錄狀態",
        SignIn: "登錄",
        Or: "或",
        RegisterNewAccount: "註冊新帳戶",
        NeedHelpContactAdmin: "需要幫助？請聯繫系統管理員",
        DonHaveAccount: "還沒有帳號?",
        SignUPnow: "註冊",
        UserPasswordError: "用戶名或者密碼錯誤",
        Cancel: "取消",
        Create: "創建",
        EmailAddress: "郵箱地址",
        VerificationCode: "驗證碼",
        Pleaseverification: "請輸入驗證碼",
        Sendverification: "發送驗證碼",
        NewPassword: "新密碼",
        passWordError1: "密碼長度為8 ~ 64個字符.",
        passWordError2: "",
        passWordError3: "- 一個小寫字母",
        passWordError4: "- 一個大寫字母",
        passWordError5: "- 一個數字",
        passWordError6: "- 一個符號",
        ConfirmNewPassword: "確認新密碼",
        PleaseConfirmPassword: "確認密碼",
        TwopasswordsInconsistent: "兩次輸入的密碼不一致!",
        RegistrationSuccess: "註冊成功", // 註冊成功
        VerificationAddress: "請點擊發送驗證碼",
        Submit: "提交",
        NoUserExists: "用戶不存在",
        CaptchaError: "驗證碼错误",
        CaptchaVerified: "驗證成功",
        emailError:"電子郵件地阯無效。",
        authenticationFailure:"身份驗證失敗",
        SsoAccountMismatch:"微軟帳號與輸入的帳號不一致，請重新登入。",
        OldPassword: "舊密碼",
        NewpasswordNotoldPassword: "新密碼不允許與舊密碼相同  ",
        OriginalPasswordError: "舊密碼錯誤 !",
        ResetPassword: "修改密碼",
        firstLoginChangePassword: "首次登入，請更改密碼",
        registerForm: "註冊表單",
        PasswordUpdatedSuccessfully: "密碼成功更新!",
        UserAlreadyExist: "用戶已存在 !",
        ResetAliasName: "修改別名",
        ChangeAliasName: "修改別名",
        dashboardPortal:"儀表板門戶",
        signOut:"登出",
        view:"查看",
        previous:"上一個",
        noReportIsSetupForThisAccount:"此帳戶未設置報告",
        PasswordExpiryWarning: "密碼過期警告",
        PasswordExpiryMessage: "您的密碼即將過期",
        PasswordExpiredToday: "密碼今天過期",
        PasswordExpiryDaysLeft: "密碼將在{days}天後過期",
        PleaseChangePasswordImmediately: "請立即更改密碼"
    },
    batchReceive: {
        BatchReceive: "批量收貨",
        Query: "查詢",
        Accept: "接收",
        All: "所有",
        Received: "收貨",
        NotReceive: "未收貨",
        ReceiveLocation: "收貨庫位",
        EnterWordsQuery: "輸入4個以上的字母進行查詢",
        EXPQty: "預期數量",
        RCVQty: "收貨數量",
        RCVQtyEA: "收貨數量 EA",
        TOID: "TOID",
        RCVLOC: "收貨庫位",
        EXPIRYDATE: "有效日期",
        Descr: "描述",
        SKU: "商品",
        UDF1: "UDF1",
        UDF2: "UDF2",
        UDF3: "UDF3",
        ReceiveRequired: "收貨庫位必填",
        RCVQtyCheck: "收貨數量需要大於 0.",
        RCVQtyGtExpQty: "收貨數量不能大於 預期數量.",
        Status: "狀態",
        Line: "行號",
        RecDate: "收貨日期",
        LocationCode: "庫位編號",
        RecQty: "收貨數量",
        RecBaseQty: "收貨數量",
        DamageQty: "破損數量",
        DamageBaseQty: "破損數量",
        HoldQty: "凍結數量",
        HoldBaseQty: "凍結數量",
        Remarks: "備註",
        Desc:"詳情",
        ProductType: "產品類型",
        ASNQty: "ASN 數量",
        ASNBaseQty: "ASN 數量",
        UOM: "單位",
        PackageQty: "打包數量",
        ManufactureDate: "加工日期",
        ExpiryDate: "有效期",
        ShelfDate: "上架日期",
        PalletID: "托盤 ID",
        CartonID: "紙箱 ID",
        TraceID:"跟蹤 ID",
        Article: "Article",
        NotAllowToOverReceive: "不允許超收.",
    },


    reportSetting: {
        DevName: "Dev Name",
        ReSQL: "Re-generate SQL",
        ColumnDetail: "Column Detail",
        ReportType: "Report Type",
        ReportVersion: "Report Version",
        EnglishName: "English Name",
        SimplifiedCNName: "Simplified CN Name",
        TraditionalCNName: "Traditional CN Name",
        EnglishTipsName: "English Tips Name",
        SimplifiedCNTipsName: "Simplified CN Tips Name",
        TraditionalCNTipsName: "Traditional CN Tips Name",
        DisplaySeq: "Display Seq",
        CalculateType: "Calculate Type",
        CustCode: "Cust Code",
        CustName: "Cust Name",
        ProjectCode: "Project Code",
        ProjectName: "Project Name",
        Beautify: "Beautify",
        Verify: "Verify",
        Generate: "Generate",
        Version: "Version",
        Assign: "分配",
        AssignName: "分配人",
        CopyFromMaster: "Copy from Master",
        plInpuSku: "Please input SKU",
        BatchSave: "Batch Save",
        SelectAllforSearchable: "Select All for Search",
        SelectAllforDisaplyable: "Select All for Display",
        importTemplate: "Import Template",
        Upload: "上傳",
        Clone: "克隆",
        importConfig: "配置",
        importColumn: "標題字段",
        Mapping: "映射字段",
        Uniquekey: "是否唯一",
        DefaultType: "默認類型",
        DataType: "數據類型",
        Datalength: "數據長度",
        
        DecimalalPlace: "保留小數位",
        DateTimeFormat: "時間格式",
        StartPosition:"開始位置",
        EndPosition:"結束位置",
        Delimiter:"分隔符",
        ReferenceKey:"Reference Key",
        RangeValue:"範圍值",
        DefaultValue: "默認值",
        Mandatory: "是否必填",
        CombineFields: "復製字段",
        UploadConfig : "上傳配置",
        FileType:"文件類型",
        Delimilter: "Delimilter",
        DelimiterDesc:"默認為 “/”, “null” 沒有分割符, “Blank” 空格",
        CloneTemplate: "克隆模板",
        TableColumn: "表 字段",
        OperationRule: "操作模式",
        withHeader: "含标题行",
        excelStartRow:"数据起始行",
        isPrintReport:"打印报表",
        printReportCode:"打印报表编号",
      },

    soPage:{
        PackedFirst:"不允許打印，請先打包!",
        inputAllQty:"請輸入分配數量!",
        labelCreateDhlShipmentId: "新建 DHL Shipment ID",
        labelAddOrderToShipmentId: "添加訂單到 Shipment ID",
        labelShipmentReference: "Shipment Reference",
        labelConfirm: "確認",
        labelQuery:"查詢",
        msgShipmentReferenceIsNull: "Shipment Reference 不能為空",
    },
  asnPage:{
    mustPutaway:"狀態必須為上架!",
    filesMaxSize:"上傳檔案總大小不能超過500M!",
    UploadPhoto: "上傳圖片",
    saveData:"您還沒有修改資料!",
    saveHeaderPlease:"請先儲存表頭資料!",
    pleaseSelectTargetProject: "請選擇目標專案。",
    targetProjectNotExist: "目標專案不存在！",
    changeWhProjectTitle: "變更倉庫/專案",
    changeWhProjectLabel: "倉庫/專案",
  },
    job:{
        Name:"Job名稱",
        Class:"Job對應的類",
        Remark:"備註",
        Type:"Job類型",
        ParamName:"參數名",
        ParamValue:"參數值",
        Seq:"序號",
        Add:"新增",
        Save:"保存",
        Run:"執行",
        Delete:"刪除",
        Reset:"重置",
        Query:"查詢",
        Total:"總共",
        Records:"條記錄",
        notNull:"不能為空!",
        Activate:"啟用",
        Inactivate:"停用",
        Action:"動作",
        Status:"狀態",
        Expression:"表達式",
        BusinessType:"業務系統類型",
        StartTime:"啟動時間",
        ActionNo:"動作編號",
        CreateExpression:"生成表達式",
        DateTime:"日期格式",
        Year:"年",
        Month:"月",
        Day:"日",
        Hour:"時",
        Minute:"分",
        Second:"秒",
        StatusCanNotDel:"啟用狀態不允許刪除!",
        ExpressionNotCorrect:"表達式錯誤!",
        TriggerStatus:"觸發器狀態",
        PrevFireTime:"上次執行時間",
        NextFireTime:"下次執行時間",
    },
    wine: {
        AvailableQty: "輸入數量超出有效庫存數量!",
        inputEnglish:"只能輸入英文",
        inputChinese:"只能輸入中文",
        maxCharacters:"最大.{0}位",
        mustInputChinese:"如果沒有填寫英文地址,則中文地址必填.",
    },
    printLabel:{
        NumberOfQrCodeLabelRequired: "Number of QR Code Label Required",
        NumberOfRelIdLabelRequired: "Number of Rel Id Label Required",
        labelType:"Label Type",
        qrCodeLabel:"Pre-Print Label",
    },
    cfs:{
        OrderCancel:"訂單攔截",
        operationSuccess:"操作成功",
        orderNo:"訂單編號",
        loadingNo:"裝箱單號",
        platformOrderNo:"Platform Order No",
        parcelNo:"條碼",
        unScanQty:"未掃描數量",
        invoiceFlag:"Print Label / Invoice Flag",
        scannedQty:"已掃描數量",
        parcelNoTrackingNo:"Parcel No. / Tracking No.(Last Mile Label)",
        trackingNo:"Tracking No.(Last Mile Label)",
        destinationCountry:"Destination Country",
        courier:"Courier",
        parcelNotOrder:"Parcel not belong to this order",
        printLabel:"Print Label",
        printDhlInvoice:"Print DHL Commercial Invoice",
        scanLoad:"掃描裝箱",
        awbMbl:"AWB / MBL / Tracking No",
        uldNo:"Container No. / ULD No.",
        collectionTimeFrom:"Collection Time From",
        collectionTimeTo:"Collection Time To",
        createLoading:"創建裝箱單",
        confirmLoading:"裝箱確認",
        ediSendFlag:"EDI Send Flag",
        resetFirst:"Please reset.",
        noOfDestinationLabelRequired:"No. of Destination Label required",
        orderNumber:"運單號",
        barcode:"條碼",
        damage:"損壞",
        dimensions:"尺寸",
        nextOrder:"下一個訂單",
        delete:"刪除",
        printViewPdf: "打印箱貼",
    },
    printerConfig: {
        refresh:"刷新打印機列表",
        servicesName:"服務器名稱",
        ip:"IP地址",
        printerName:"打印機名稱",
    },
    scanPack:{
        cancelCheckCompleteMsg:'確認移除所有包裝好的紙箱?',
        cancelCheckCompleteMoveMsg: '是否將所有取消的庫存移回原始位置?',
        cancelCheckCompleteNo:'否',
        cancelCheckCompleteYes:'是',
        title: '確定',
        currentScanQty:'當前掃描數量',
        deletePickingData:"確認刪除揀貨數據嗎",
        firstCancelCheckCompleteThenScanPack:"當前訂單存在部分復核完成,是否取消復核完成",
        antiCounterfeitingCodePleaseConfirm:"非出庫防偽碼，請確認。",
        currentBrand:"當前品牌",
        getExpressNumber:"獲取快遞單號",
        ssccAlreadyUse:"SSCC#{0} 不允許混合包裝訂單",
        scanByWave:"請使用 波次ID ( {0} )掃描",
        notAllowedBatchClose: "當前裝箱數據未提交，不允許批量關箱"
    },
    skuSearch:{
      skuSearch: "商品搜索",
      upcSearch: "UPC 搜索",
      sku: "商品碼",
      multipleSku: "批量商品碼",
      skuFrom: "起始商品碼",
      skuTo: "結束商品碼",
      search: "搜索",
      skuCode: "商品碼",
      skuDesc: "商品描述",
      upc: "商品條碼",
      style: "款式",
      color: "顏色",
      size: "尺寸"
    },
    invTrans:{
        transType:"事務類型",
        transStatus:"事務狀態",
        orderNo:"單證號",
        transTimeFrom:"事務時間從",
        transTimeTo:"事務時間到",
        systemUser:"系統人員",
        lotAttribute:"批次屬性",
        ownerCode:"貨主",
        lotNo:"批號",
        id:"跟蹤號",
        back:"返回",
        transId:"事務編號",
        transTime:"事務時間",
        lineNo:"行號",
        operator:"操作人",
        ownerCodeFrom:"貨主從",
        ownerCodeTo:"貨主到",
        skuFrom:"商品從",
        skuTo:"商品到",
        skuDescFrom:"商品名稱從",
        skuDescTo:"商品名稱到",
        lotNoFrom:"批次號從",
        lotNoTo:"批次號到",
        idFrom:"跟蹤號從",
        idTo:"跟蹤號到",
        locFrom:"庫位從",
        locTo:"庫位到",
        qtyFrom:"數量從",
        qtyTo:"數量到",
        unitQtyFrom:"單位數量從",
        unitQtyTo:"單位數量到",
        uomFrom:"單位從",
        uomTo:"單位到",
        descriptionFrom:"描述從",
        descriptionTo:"描述到",
        amount:"金額",
        typeMustBeSelected:"必須選擇操作類型",
        pleaseSelectAQueryPeriod:"請選擇查詢時間段",
    },
    billingMaintance: {
        add:"新增",
        query:"查詢",
        reset:"重置",
        billId:"賬單號",
        cutOffDate:"截止時間",
        billingPeriodFrom:"計費開始時間",
        billingPeriodTo:"計費結束時間",
        confirmDate:"確認日期",
        postDate:"發布日期",
        invoiceNo:"發票號",
        invoiceDate:"發票日期",
        billToName:"收件人",
        billToAddress1:"地址1",
        billToAddress2:"地址2",
        billToAddress3:"地址3",
        billToAddress4:"地址4",
        billToCity:"市",
        billToProvince:"省",
        billToCountry:"國家",
        billToZip:"郵編",
        billToContactName:"聯系人",
        billToContactPhone:"聯系電話",
        billToContactFax:"傳真",
        billToContactEmail:"郵件",
        currency:"幣種",
        exchangeRate:"匯率",
        lineNo:"行號",
        chargeMethod:"費用方法",
        tariffId:"稅率",
        chargeCode:"費用",
        description:"描述",
        billDateFrom:"賬單開始時間",
        billDateTo:"賬單結束時間",
        billType:"賬單類型",
        billBase:"賬單基礎",
        billUnit:"單位",
        overflowCharge:"溢出費用",
        accountCode:"賬戶",
        localExchangeRate:"當地匯率",
        baseAmount:"基礎金額",
        localAmount:"本地金額",
        totalAmount:"總金額",
        invoiceLineSeq:"發票行號",
        CreateMaintance:"創建",
        EditMaintance:"編輯",

    },
    resPlan:{
      workingDayOnly:"只适用于工作日",
      waveIdNotnull:"波次號不能為空",
      needCreateResourcePlan:"是否需要創建Resource Planning?",
    },
    cycleCount:{
        Location: "庫位編號",
        createTicket: "創建票數",
        includeStatus: "包含狀態",
        reCount: "重新計數",
        numberOfSplit: "拆分次數",
        confirmToCreateTicketForLocation:"是否確認開始或再次盤點以下包括盤點記錄外的庫位？",
        confirmToReCountLocation:"是否確認再次盤點庫位？"
    },
    handheldConfiguration:{
        handheldConfiguration:"手持式配置",
        handheldApplicationConfiguration:"手持機應用配置",
        configName:'配置名稱',
        relatedFunction:'相關功能',
        status:'狀態',
        flowSetting:'流動設置',
        orderSearch:'訂單查詢',
        scanning:'掃描',
        haveSearchScreen:'是否搜索畫面?',
        scanName:'掃描名稱',
        promptMessage:'提示信息',
        actionSettings:'行動設置',
        action:'行動',
        targetField:'目標字段',
        field:'字段',
        stepSettings:'步驟設置',
        new: "新",
        value:'值',
        type:'類型',
        length:'長度',
        dataLength:'數據長度',
        relatedSettings:'相關設置',
        lockValue:'查找值?',
        displayIn:'顯示在?',
        showCurrProgress:'顯示當前進度',
        showSummary:'顯示總結',
        info:'信息',
        showConfDialog:'顯示配置對話框',
        displayText:'展示文本',
        changeCommand:'改變命令',
        last:'(最新)',
        completeOnCloseNext:'關閉/下一個 完成?',
        suggestLocation:'建議庫位?',
        dialogSettings:'對話框設置',
        input:'輸入',
        mandatory:'Mandatory',
        dimension:'必填',
        volume:'體積',
        grossWeight:'毛重',
        netWeight:'淨重',
        logicSettings:'邏輯設置',
        use:'使用',
        priority:'優先權',
        lastLocation:'最新庫位',
        nextEmptyLocation:'下一個空庫位',
        pickLocation:'揀貨庫位',
        storageLocation:'存儲庫位',
        closeToSameSku:'關閉相同的sku',
        matchItemType:'匹配相同類型',
        useProjectLocation:'使用項目庫位',
        useWarehouseLocation:'使用倉庫庫位',
        scanSingle:'單行掃描?',
        displayInformation:'顯示信息',
        scanningScanNameCannotBeEmpty:'掃描 {0} 掃描名稱不能為空.',
        orderSearchScanNameCannotBeEmpty:'訂單查詢掃描名稱不能為空.',
    },
    cycleCountMaster:{
        belowLocationAndSku:"以下位置和SKU有分配數量/持有數量，您確定要忽略它們來創建盤點訂單嗎？",
        quantityNeedsToBeGreaterThan0:"數量需要大於 0",
        createCountOrderByNumber:"按默認計數次數創建盤點單?",
        countOrderCompleteOrder:"庫存盤點 {0} 及其相關票證仍在處理中\n" +
            "您是否希望關閉未結清的交易並完成庫存盤點?",
    },
    confirmDeleteLoading:"訂單已經裝車,確認要從裝車單中移除嗎?",
    expDeliveryDateNotnull:"預計發貨日期不能為空!",
    scanIn:"收貨掃描",
    carrier:"承運人",
    flightNo:"航班號",
    parcelUnWeighed:"包裹未稱重",
    airLine:"航空公司",
    services:"服務",
    servicesProvider:"服務商",
    gatewayCannotBeEmpty:"Gateway不能為空",
    serviceCannotBeEmpty:"服務不能為空",
    serviceProviderCannotBeEmpty:"服務商不能為空",
    skynetPostal:"郵政渠道",
    battery:"電池",
    batteryCannotBeEmpty:"電池不能為空",
    copyLoading:"複製裝箱單",
    showAll:"展示所有",
    processActionMsg:"是否確認此操作?",
    orderRef: "訂單號",
    printNotConnected: "打印機連接失敗",
    notLabelRecord:"未找到记录",
    collarBarcode:{
        woolenCollarBarcode:"毛領子條碼",
        woolenCollarBarcodeMismatch:"毛領子條碼不匹配",
        missing:"缺失",
    },
    soStatus:{
        partialAllocated:"部分分配",
        allocation:"分配",
        partialPicked:"部分揀貨",
        picked:"完全揀貨",
        partialPacked:"部分裝箱",
        packed:"完全裝箱",
        partialLoaded:"部分裝車",
        loaded:"完全裝車",
        partialShipped:"部分發運",
        shipped:"完全發運",
        delivered:"递送",
        billed:"账单",
        //closed:"订单完成",
        cancelled:"订单取消",
        deleted:"删除",
        closed:"訂單完成",
    },
    asnStatus:{
        partialReceived:"部分收貨",
        received:"完全收貨",
        partialPutaway:"部分上架",
        putaway:"完全上架",
        cancelled:"取消狀態",
        deleted:"刪除狀態",
        closed:"關閉狀態",
    },
    loading:{
        loadId:"裝車ID",
        container:"裝車號",
        hidden: "隱藏",
        searchCartonByWave:"按波次搜索箱",
        importSscc:"導入SSCC",
        seal:"密封號",
        containerType:"裝車類型",
        vesselFight:"輪船",
        voyage:"航綫",
        mbl:"MBL",
        hbl:"HBL",
        driver:"駕駛員",
        etd:"預計離開時間",
        eta:"預計到達時間",
        portOfLoading:"裝貨港",
        portOfDischarge:"卸貨港",
        portOfDestination:"目的港",
        loadFrom:"裝車開始時間",
        loadTo:"裝車結束時間",
        remarks:"備注",
        loadedCartonQty:"裝車箱數量",
        detailSearch:"詳細信息搜索",
    },
    filterBy:"篩選",
    allocationResults: "分配結果",
    importResults:"導入結果",
    lastestNotifications:"最近{0}條通知",
    todayNotifications:"今天的通知",
    yesterdayNotifications:"昨天的通知",
    success:"成功",
    failed:"失敗",
    inputNumCharsThenPressEnter:"請輸入{0}個或以上字符后按<enter>",
    queryCondition:"查詢條件",
    thaiName:"泰語",
    japaneseName:"日語",
    headerJoinFieldName:"主關聯字段",
    detailJoinFieldName:"明細關聯字段",
    queryFieldName:"查詢字段",
    compareType:"比較類型",
    fixedValue:"固定值",
    pageType:"頁面類型",
    codeMasterGroup:"數據字典組",
    queryTable:"字段所屬表",
    headerTable:"主關聯表",
    detailTable:"明細關聯表",
    splitScan: {
        queryConditionCantBeNull: "查詢條件不能為空",
        skuCannotBeEmpty: "商品編碼不能為空",
        noUnreviewedProductsExist:"不存在未複核商品",
    },
    stdBalanceReport: {
        brand: "品牌",
        size: "尺寸",
        volume: "單個體積m³",
        totalVolume: "總體積m³",
        minRecDate: "原始入庫時間",
        department: "部門",
        sku: "商品",
        skuName: "品名",
        material: "物料款號/代碼",
        specification: "規格",
        keyword: "糢餬",
        units: "單位",
        qty: "數量",
        inboundTime: "最近入庫時間",
        outboundTime: "最近出庫時間",
        period: "時期",
        remark: "備註/描述",
        Location: "庫位",
        prePicture: "圖片預覽",
    },
    sessionModal: {
        title: "登錄已過期",
        message: "由於長時間未操作，請重新登錄",
        passwordChangedMessage: "密碼已修改，請重新登入",
        username: "用戶名",
        password: "密碼",
        loginButton: "登錄",
        logoutButton: "退出",
        usernameRequired: "請輸入用戶名和密碼",
        passwordRequired: "請輸入密碼",
        loginFailed: "登錄失敗，請檢查用戶名和密碼",
        loginError: "登錄失敗，請重試",
        loginSuccess: "重新登錄成功",
        loginLoading: "登錄中...",
        loginTimeout: "請求超時，請重試",
        securityTitle: "安全警告",
        securityMessage: "檢測到未授權的數據修改，為了您的安全請重新登錄",
        securityWarning: "為了您的安全，請驗證您的身份",
        tokenExpiredMessage: "工作階段已過期，請重新登入",
        tokenInvalidMessage: "登入憑證無效，請重新登入",
        noPermissionTitle: "無權限",
        noPermissionMessage: "您沒有權限存取該資源",
        okButton: "確定",
        projectChangedTitle: "項目已變更",
        projectChangedMessage: "目前項目已發生變化，請重新整理頁面以載入正確的項目資料",
        reloadButton: "刷新頁面",
        reloginButton: "重新登入"
    },
    projectQueryList:"項目查詢列表",
    defaultQueryList:"默認查詢列表",
    hide:"隱藏",
    show:"显示",
    copyToProjectList:"複製到項目查詢列表",
    copyToAnotherLanguage:"複製到其他語言",
    copyToAnotherProject:"複製到其他項目",
    copyTo:"複製到",
    DueDateUpdateConfirm:"以下波次已包含掃描包截止日期。確認更新嗎？",
    domain:"域",
    singleSignOn:"單點登錄",
}
